angular.module('impactx.sidebar').component('ixMenuSidebar', {
        replace: true,
        controller: 'MenuSidebarCtrl',
        templateUrl: 'shared/sidebar/templates/sidebar.html'
    }
);